var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thank_you",staticStyle:{"cursor":"pointer"}},[_c('thank-you')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }